import {useEffect} from "react";
import Typography from "@mui/material/Typography";
import * as React from "react";
import {checkBarcodeToken} from "./UserService";

const BarcodeChecker = ({imageBarcode, barcode}) => {

    useEffect(() => {
        const interval = setInterval(async () => {
            await checkBarcodeToken()
        }, 3000);
        return () => clearInterval(interval);
    }, [barcode]);

    return <>
        <Typography>
            <img alt={"barcode"} src={imageBarcode}/>
        </Typography>
    </>
}

export default BarcodeChecker